import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useNavigate, useLocation, Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import AppButton from "../../common/AppButton";
import AppErrorMessage from "../../common/AppErrorMessage";
import LoadingSpinner from "../../common/Loading";

interface IProps {
  handleContinue: any;
  handleInputChangeForget: any;
  errors: any;
  forgetPassValue: any;
  forgetError: any;
}

const LoginForgetPassword = ({
  handleContinue,
  handleInputChangeForget,
  errors,
  forgetPassValue,
  forgetError,
}: IProps) => {
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const { isLoading, isLoginError, loginMessage } = useAppSelector(
    (state: any) => state?.auth
  );
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery("(max-width: 1022px)");

  return (
    <>
      <Box
        sx={{
          paddingLeft: isMobile ? "0px" : "30px",
          paddingRight: isMobile ? "0px" : "30px",
        }}
      >
        <Box sx={{ textAlign: "center", fontSize: "18px", fontWeight: 500 }}>
          Forgot Password?
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            mb: 4.5,
            mt: 2,
          }}
        >
          Please enter the number associated with your account
        </Box>
        <TextField
          label="Mobile Number or Email"
          name="email"
          value={forgetPassValue?.email || forgetPassValue?.phone_number}
          onChange={handleInputChangeForget}
          error={Boolean(errors.email)}
          helperText={errors.email}
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: "40px", // Set the total height of the input field
              padding: "0", // Remove default padding
              display: "flex",
              alignItems: "center", // Center the input content
              justifyContent: "center",
            },
            "& .MuiFormLabel-root": {
              top: "-5px", // Adjust label positioning if necessary
            },
            "& .MuiInputBase-input": {
              padding: "0 10px", // Add inner padding for input
              height: "100%", // Fill the container's height
              boxSizing: "border-box",
            },
          }}
        />
        <Box sx={{ mt: 2 }}>
          {forgetError && <AppErrorMessage message={forgetError} />}
        </Box>
        <AppButton
          title="Continue"
          onClick={handleContinue}
          fullWidth
          variant="contained"
          sx={{ mt: 4, mb: 2 }}
        />
      </Box>
    </>
  );
};

export default LoginForgetPassword;
